import { API } from "../apis/APIsConfig";
import Constants from "../utils/constants";

export type QueryResponseCode =
  | "ENCONTRADO"
  | "NO_ENCONTRADO"
  | "SIN_DATOS"
  | "ERROR"
  | "ENVIADO"
  | "NO_ENVIADO"
  | "OK";

export interface QueryLogPayload {
  serviceKey: string;
  identifier: string;
  queryAt: string;
  responseCode: QueryResponseCode;
  responseMessage: string;
  responsePayload?: string | null;
  source?: string;
}

export function logQuery(payload: QueryLogPayload) {
  return API.post(Constants.APIURLS.GRABAR_BITACORA, payload);
}

